import { render } from "./YouthDirectoryForm.vue?vue&type=template&id=629339ad&scoped=true"
import script from "./YouthDirectoryForm.vue?vue&type=script&lang=js"
export * from "./YouthDirectoryForm.vue?vue&type=script&lang=js"

import "./YouthDirectoryForm.vue?vue&type=style&index=0&id=629339ad&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629339ad"]])

export default __exports__